// ConduitsDropDown.tsx
import {useState} from "react";
import * as React from "react";
import "./index.css"

// params: model or UImodel (main model control elements)
// UIparams: css styles for objects and controls.
// controlParams: parent data model. Mostly for non-model controls e.g.: charting, reporting.
// objName: tha name of the object to be updated in the controlModel object if this control is changed.
const ConduitsDropDown = ({onChange, CONDUITS}: any) => {
  const [selected, setSelected] = useState(' ')

  // If the model changes, then 
  // the displayed value must also change
  // Adjust for cases where val is null.
  React.useEffect(() => {
    setSelected('none')
  }, [CONDUITS])

  const handleChange = ({target}:any) =>{
    setSelected(target.value)
    onChange({name: 'conduit', value: target.value})
  }

  return(
    <div>
      <select
        className='UIparams swmmDropDown'
        value = {selected}
        onChange = {handleChange}
      >
        <option value='none' disabled hidden>Select a Conduit</option>
        {
          Object.keys(CONDUITS?CONDUITS:{})
            .map((k, i) => 
              <option className='UIparams' key={i} value={k}>{k}</option>
            )
        }
      </select>
    </div>
  )
};
 
export {ConduitsDropDown};